module.exports = __webpack_public_path__ + "img/common.7a551d6f.png";